        <p class="text-uppercase">{{lineWords_params.title}}</p>
        <div *ngFor="let word of lineWords_params.words" >
                <h2 data-aos="fade-right" data-aos-duration="1000">{{word}}<span class="fw-bolder">{{lineWords_params.postWord}}</span></h2>
        </div>
        
       
